import { useLayoutEffect } from 'react';

const SeoResourceRedirect = ({ resource }) => {
  useLayoutEffect(() => {
    window.location.replace(`/api/v1/seo/${resource}`);
  }, [resource]);

  return null;
};

export default SeoResourceRedirect;
